import React from 'react'
import Waitlist from '../components/Waitlist'
import { XCircleIcon } from '@heroicons/react/24/solid'
import { Dialog } from '@headlessui/react'

const WaitlistCTA = () => {
  const [isOpen, setIsOpen] = React.useState(false)
  const openDialog = () => setIsOpen(true)
  const closeDialog = () => setIsOpen(false)
  return (
    <div className="bg-gradient-to-tr from-[#a080ff]/10 to-[#5349e4]/10 ">
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        open={isOpen}
        onClose={closeDialog}
      >
        <div className="flex items-center justify-center min-h-screen">
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
          <div className="relative">
            <Waitlist />
            <XCircleIcon
              className="absolute h-8 w-8 -top-2 -right-2 text-blue-400 hover:text-blue-500 cursor-pointer"
              onClick={closeDialog}
            />
          </div>
        </div>
      </Dialog>
      <div className="mx-auto max-w-5xl px-6 py-24 sm:py-32 lg:flex lg:items-center lg:justify-between lg:px-8">
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Supercharge your Looker work.
          <br />
          Join the waitlist today.
        </h2>
        <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:flex-shrink-0">
          <div
            onClick={openDialog}
            className="rounded-md bg-ddu-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-ddu-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ddu-blue-600 cursor-pointer"
          >
            Join Waitlist
          </div>
        </div>
      </div>
    </div>
  )
}

export default WaitlistCTA
